import { Component, DestroyRef, inject, Input, OnInit, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Dialog } from '@frontend/shared/services/dialog.service';
import { Store } from '@ngrx/store';
import { CurrUser } from '@proman/interfaces/object-interfaces';
import { AppLoader } from '@proman/services/app-loader.service';
import { Entity } from '@proman/services/entity.service';
import { LanguageConfigService } from '@proman/services/language-config.service';
import { OnlineStatusService } from '@proman/services/online-status.service';
import { UI_DARK_MODE, UiPreferencesService } from '@proman/services/ui-preferences.service';
import { getCurrUserUiPrefs } from '@proman/store/curr-user/curr-user.selectors';
import { isTouchDevice } from '@proman/utils';

@Component({
    selector: 'pm-proman',
    template: `
        <pm-layout fxLayout="column" fxFlex="auto">
            <pm-header></pm-header>
            <pm-toolbar></pm-toolbar>
            <router-outlet></router-outlet>
        </pm-layout>
    `,
    standalone: false,
})
export class MainComponent implements OnInit {
    private AppLoader = inject(AppLoader);
    private LanguageConfig = inject(LanguageConfigService);
    private route = inject(ActivatedRoute);
    private Dialog = inject(Dialog);
    private Entity = inject(Entity);
    private Render2 = inject(Renderer2);
    private UiPrefs = inject(UiPreferencesService);
    private OnlineStatus = inject(OnlineStatusService);
    private store = inject<Store>(Store);
    destroyRef = inject(DestroyRef);

    @Input() user: CurrUser;
    isDarkMode: boolean;

    constructor() {
        this.user = this.route.snapshot.data['user'];

        this.store
            .select(getCurrUserUiPrefs)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((uiPrefs) => {
                this.isDarkMode = uiPrefs[UI_DARK_MODE];
                this.Render2[this.isDarkMode ? 'addClass' : 'removeClass'](document.querySelector('html'), 'dark-mode');
            });
    }

    ngOnInit() {
        this.AppLoader.remove();

        this.LanguageConfig.set(this.user.language);

        let _isTouchDevice = isTouchDevice();

        if (_isTouchDevice) {
            this.Render2.addClass(document.querySelector('html'), 'MobileDevice');
        }
    }
}
